require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-team-allen-tushabe.json") })
        }
      }, "path---en-us-team-allen-tushabe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-team-allen-tushabe!./.cache/json/en-us-team-allen-tushabe.json
// module id = 586
// module chunks = 231608221292675